import { Stage } from '@/constants/interfaces';

function extractedStageFrom(hostname: string): Stage {
  const matchedGroups = hostname.match(/app.([a-z]+).dga.avp.tech/);
  if (matchedGroups !== null) {
    const stage = matchedGroups[1].toLowerCase();
    switch (stage) {
      case 'dev':
        return Stage.DEV;
      case 'test':
        return Stage.TEST;
    }
  }

  console.warn(`Unable to extract stage from ${hostname}. Falling back to DEV stage.`);
  return Stage.DEV;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const fromDerivedStage: (hostname: string) => Stage = (hostname: string) => {
  if (!hostname) {
    return Stage.DEV;
  }

  if (hostname === 'app.dga.avp.tech' || hostname.startsWith('www.audi')) {
    return Stage.PROD;
  }

  if (hostname === 'localhost' || hostname.startsWith('pre-www.audi')) {
    return Stage.DEV;
  }
  return extractedStageFrom(hostname);
};
